import { motion } from "framer-motion";
import { Shield, TrendingUp, Users, BookOpen, Target, Crown } from "lucide-react";

const features = [
  {
    icon: TrendingUp,
    title: "Investment Strategies",
    description: "Gain a deep understanding of wealth-building principles and proven investment strategies that work.",
  },
  {
    icon: Shield,
    title: "Asset Protection",
    description: "Safeguard what you've built from unnecessary risk, taxes, and legal exposure.",
  },
  {
    icon: Users,
    title: "Ongoing Support & Guidance",
    description: "Our dedicated team helps you overcome obstacles, stay motivated, and navigate your path to financial independence.",
  },
  {
    icon: BookOpen,
    title: "Dynamic Learning",
    description: "A rich, interactive environment with expert-led modules designed for busy professionals.",
  },
  {
    icon: Target,
    title: "Implementation & Results",
    description: "This isn't just knowledge — every lesson comes with clear next steps you can implement immediately.",
  },
  {
    icon: Crown,
    title: "Money Management Mastery",
    description: "Master effective money management techniques that protect and grow your wealth for generations.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-24 md:py-32 relative bg-secondary/30">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_hsl(43_72%_55%_/_0.03),_transparent_70%)]" />

      <div className="container mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16 space-y-4"
        >
          <p className="text-xs uppercase tracking-[0.4em] text-gold font-body font-medium">
            What You'll Gain
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground">
            Built for Your <span className="text-gradient-gold">Legacy</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              whileHover={{ y: -4, transition: { duration: 0.3 } }}
              className="group p-8 border border-gold/10 bg-card/50 backdrop-blur-sm hover:border-gold/30 transition-all duration-500"
            >
              <feature.icon className="w-8 h-8 text-gold mb-5 group-hover:text-gold-light transition-colors duration-300" />
              <h3 className="text-lg font-display font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground font-body text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
